<template>
  <v-app>
    <GroupBar v-if="isLoggedIn" :user="user" />
    <notifications position="top center" class="toastFontSize" />
    <DialogLgpd />
    <v-main>
      <PromoBannerStrip />
      <router-view
                   v-slot="{ Component }"
                   style="position: relative; z-index: 100 !important">
        <keep-alive>
          <component :is="Component" @logged-in="revalidateUser" :user="user" />
        </keep-alive>
      </router-view>
      <v-navigation-drawer
                           v-if="$route.meta.showNavDrawer"
                           v-model="navDrawer"
                           expand-on-hover
                           :rail="railNavDrawer"
                           :permanent="!railNavDrawer"
                           :floating="!railNavDrawer">
        <v-list-item
                     :active="$route.name == 'Account'"
                     @click="$router.push({ name: 'Account' })"
                     :prepend-avatar="userAvatar"
                     :title="user.name"
                     nav>
          <template v-slot:append>
            <v-btn
                   variant="text"
                   icon="mdi-chevron-left"
                   @click.stop="railNavDrawer = !railNavDrawer"></v-btn>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list nav>
          <template v-for="(route, index) in menuRoutes">
            <v-divider v-if="route.meta.divider_above"></v-divider>
            <v-list-item
                         :key="index"
                         v-if="route.meta.showOnNavDrawer && checkRouteAccess(route.meta.access_level, user.access_level, route.meta.access_level_logic)"
                         @click="$router.push(route)"
                         :active="route.name == $route.name"
                         :prepend-icon="route.meta.icon"
                         :title="route.meta.title || route.name"
                         :value="route.path"></v-list-item>
            <v-divider v-if="route.meta.divider_below"></v-divider>
          </template>
          <v-divider></v-divider>
          <v-list-item
                       :href="pdvApkHref"
                       prepend-icon="mdi-cellphone-android"
                       title="Baixar app PDV"
                       nav></v-list-item>
        </v-list>
      </v-navigation-drawer>
      <v-app-bar v-if="$route?.meta?.showAppBar">
        <template v-slot:title>
          <v-btn v-if="railNavDrawer" @click="railNavDrawer = !railNavDrawer" variant="text"
                 icon><v-icon>mdi-menu</v-icon></v-btn>
          {{ $route.meta.title || $route.name }}
        </template>
        <template v-slot:append>
          <v-btn @click="api.auth.logoutAndRedirect()" icon="mdi-logout"></v-btn>
        </template>
      </v-app-bar>
      <v-footer v-if="$route.meta.appFooter">
        <div style="width: 100%">
          <Copyright />
        </div>
      </v-footer>
    </v-main>
  </v-app>
</template>
<style>
.fakeLink {
  text-decoration: underline;
  cursor: pointer;
}

.toastFontSize .notification-content {
  font-size: 18px;
}

.v-autocomplete__content {
  max-height: 46vh !important;
}

.otpInput>div {
  margin: auto;
}

.otp-input {
  width: 50px;
  height: 50px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 3px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}

/* Background colour of an input field with value */
.otp-input.is-complete {
  background-color: #696969;
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input::placeholder {
  font-size: 15px;
  text-align: center;
  font-weight: 600;
}
</style>
<script>
import assets from "./assets/assets";
import { PDV_APK_PATH } from './constants/pdvApp';
import Copyright from './components/Copyright.vue';
import GroupBar from './components/GroupBar.vue';
import DialogLgpd from './components/DialogLgpd.vue';
import PromoBannerStrip from './components/PromoBannerStrip.vue';
import { useDisplay } from 'vuetify';
import api from '@/services'
export default {
  setup() {
    const { mdAndUp } = useDisplay()
    return { api, mdAndUp }
  },
  components: { Copyright, GroupBar, DialogLgpd, PromoBannerStrip },
  data() {
    return {
      assets: assets,
      routes: [],
      user: {},
      railNavDrawer: this.mdAndUp,
      navDrawer: null,
      isLoggedIn: false,
    };
  },
  created() {
    var vm = this
    vm.isLoggedIn = api.auth.isLoggedIn()
    let _r = localStorage._railNavDrawer
    vm.railNavDrawer = _r == 'false' ? false : true
    api.auth.me().then((resultUser) => {
      vm.user = api.auth.user()
    }).catch((err) => {
      console.error(err)
    });
  },
  mounted() {
    var vm = this;
    vm.user = api.auth.user();
    document.title = `GGrupos v${vm.version}`;
    let _dark = localStorage._dark;
    if (_dark == 0) {
      vm.$vuetify.theme.change("light");
    } else {
      vm.$vuetify.theme.change("dark");
    }
  },
  methods: {
    revalidateUser() {
      var vm = this
      vm.user = api.auth.user();
      vm.isLoggedIn = api.auth.isLoggedIn()
    },
    checkRouteAccess(routeAccess, userAccess, mathOperator) {
      switch (mathOperator) {
        case '>':
          return userAccess > routeAccess
        case '<':
          return userAccess < routeAccess
        case '==':
          return userAccess == routeAccess
        case '>=':
          return userAccess >= routeAccess
        case '<=':
          return userAccess <= routeAccess
        case '!=':
          return userAccess != routeAccess
        case 'IN':
          return routeAccess.some(access => [access].includes(userAccess))
        default:
          return true
      }
    },
  },
  computed: {
    pdvApkHref() {
      return PDV_APK_PATH
    },
    menuRoutes() {
      var vm = this
      let _routes = vm.$router.getRoutes()
      // if (vm.user?.access_level == vm.$USER_ACCESS_LEVELS_DIC.GROUP_ADMIN.value)
      // _routes.splice(1, 0, _routeGroup);
      return _routes
    },
    userAvatar() {
      const vm = this;

      if (vm.isLoggedIn && vm.user?.img) return vm.user.img;
      if (vm.isLoggedIn && vm.user?.legal_person?.gender === 'Masculino') return vm.assets.default_male_avatar;
      if (vm.isLoggedIn && vm.user?.legal_person?.gender === 'Feminino') return vm.assets.default_female_avatar;
      return vm.assets.logo;
    }
  },
  watch: {
    railNavDrawer(newVal) {
      localStorage._railNavDrawer = newVal
    },
  }
};
</script>
